import { apiClient } from '~/api/client';
import { VerificationOption } from '~/components/verification-request/types';

export type CreateVerificationParams = {
  options: VerificationOption;
  agent_id: number;
  comment: string;
};

export const create = async (params: CreateVerificationParams) =>
  apiClient.post('/verification_requests', params);
